import { createFileRoute } from "@tanstack/react-router";
import { LegalLayout } from "@/components/LegalLayout";

export const Route = createFileRoute("/legal/acceptable-use")({
  head: () => ({
    meta: [
      { title: "Acceptable Use Policy — The Hospitality Reserve" },
      {
        name: "description",
        content:
          "Rules governing acceptable conduct on The Hospitality Reserve platform, including prohibited behaviour and how to report violations.",
      },
      { property: "og:title", content: "Acceptable Use Policy — The Hospitality Reserve" },
      { property: "og:url", content: "https://thehospitalityreserve.com/legal/acceptable-use" },
    ],
    links: [{ rel: "canonical", href: "https://thehospitalityreserve.com/legal/acceptable-use" }],
  }),
  component: AupPage,
});

function AupPage() {
  return (
    <LegalLayout eyebrow="Legal" title="Acceptable Use Policy" updated="18 August 2026">
      <p>
        This Acceptable Use Policy ("AUP") forms part of our Terms of Service
        and applies to all users of the Platform.
      </p>

      <h2>You must not</h2>
      <ul>
        <li>
          Use the Platform if you are under 18 or do not have the legal right
          to work in the United Kingdom.
        </li>
        <li>
          Misrepresent your identity, qualifications, certifications, DBS
          status, or right-to-work.
        </li>
        <li>
          Circumvent the Platform by contacting a counterparty discovered
          through the service and agreeing or paying for casual, shift-based
          engagements off Platform. This removes the protections (vetting
          records, dispute handling, payment escrow) we provide. This does not
          apply to permanent or direct employment, which is always free and
          always allowed.
        </li>

        <li>
          Harass, discriminate against, threaten, or behave abusively toward
          any other user or member of staff.
        </li>
        <li>
          Attend an engagement under the influence of alcohol or unlawful
          substances, or serve alcohol to anyone under 18.
        </li>
        <li>
          Use the Platform for any unlawful purpose, including modern slavery,
          tax evasion facilitation, money laundering, or sanctions evasion.
        </li>
        <li>
          Scrape, reverse-engineer, probe, or attempt to gain unauthorised
          access to the Platform.
        </li>
        <li>
          Upload malware, defamatory content, or content that infringes
          intellectual property or privacy rights.
        </li>
      </ul>

      <h2>Zero tolerance</h2>
      <p>
        Theft, physical violence or threats of violence, and any other illegal
        conduct are treated as gross misconduct. A Venue may end a shift
        immediately on those grounds; pay is then limited to the hours actually
        worked up to termination and funds are frozen while we investigate. Any
        substantiated claim results in an immediate, permanent ban, and we may
        share identity verification and booking records with the police. See the{" "}
        <a href="/legal/terms">Terms of Service</a> for the full policy.
      </p>

      <h2>Reporting</h2>
      <p>
        Report violations to{" "}
        <a href="mailto:trust@thehospitalityreserve.com">trust@thehospitalityreserve.com</a>.
        We investigate every report and may suspend or terminate accounts that
        breach this AUP.
      </p>
    </LegalLayout>
  );
}
